import React, { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { IoMdArrowBack } from "react-icons/io";
import { Button, Col, Container, Modal, Row } from "reactstrap";
import { FaYoutube } from "react-icons/fa6";
import img from "../../assets/img/custom/TALKING_BADGES_YOU_love.png";
import previewTalkingBadge from "../../assets/img/custom/talkingbadges_preview.png";

const Badges = () => {
  const [modal, setModal] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);

  const toggle = () => setModal(!modal);

  const handleSiteSelection = (site) => {
    setSelectedSite(site);
    toggle();
  };

  const getContinueLink = () => {
    if (selectedSite === "fan") {
      return "https://fhp-fans.web.app/auth/login?redirect=/fan/badges-gallery-talking";
    } else if (selectedSite === "athlete") {
      return "https://fans-help-players-athlete.web.app/auth/login?redirect=/admin/talking-badges";
    }
    return "#";
  };
  return (
    <>
      <div className="bg-white ">
        <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </button>{" "}
        <Container fluid="md" className="talking-badges-container">
          <div className="talking-badges ">
            <Button
              className="mt-6 "
              color="primary"
              onClick={() => handleSiteSelection("fan")}
            >
              Go to fan site
            </Button>
            <Button
              className=" mt-1 "
              color="primary"
              onClick={() => handleSiteSelection("athlete")}
            >
              Go to athlete site
            </Button>

            <a
              className="text-white btn btn-primary  p-1 px-2 mt-2"
              href="https://youtu.be/UjNrz3IO-Do"
              target="_blank"
            >
              <FaYoutube className="youtube-icon" /> Play Video
            </a>
            <img src={img} alt="" />
          </div>
        </Container>
        {/* <div className="text-center  py-2">
        <img src={badgeImg} alt="badgeImg" width="100%" />
        <a
          href="https://fhp-fans.web.app/fan/search-player"
          className="btn btn-primary"
          target="_blank"
        >
          Search
        </a>
      </div> */}
      </div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="xl"
        className="modal-dialog modal-dialog-centered"
      >
        <Row>
          <Col lg="12">
            <div className="complaint-card shadow">
              <Row className="p-3">
                <Col className="col-7">
                  <div className="border border-dark">
                    <h1 className="font-weight-bolder text-center">
                      TALKING BADGES 
                    </h1>
                  </div>
                  <p className="font-weight-normal mt-2">
                    You are&nbsp;
                    <b className="text-danger">REALLY GOING TO ENJOY&nbsp;</b>
                    this series of&nbsp;
                    <b className="text-primary">TALKING BADGES&nbsp;</b>
                    {/* <b className="text-danger">
                      & INSTANT ONLINE VIDEO VIEWS
                    </b> */}
                  </p>
                  <p className="font-weight-normal mt-2">
                    These&nbsp;
                    <b className="text-dark ">
                      T.B.s&nbsp; at{" "}
                      <b>
                        <b className="text-dark">Fans</b>
                        <b className="text-primary">Help</b>
                        <b className="text-danger">Players</b>
                      </b>{" "}
                    </b>
                    can be of two types:&nbsp;
                    <b className="text-danger">a diary entry</b>
                    &nbsp;made by&nbsp;
                    <b className="text-danger">
                      YOUR FAVORITE Student Athlete,
                    </b>
                    &nbsp;
                    <b className="text-primary">
                      or a video selected FOR HUMOR AND FUN
                    </b>
                    &nbsp; by the Student Athlete for you, i.e., his or her
                    fans.​
                  </p>

                  <p className="font-weight-normal mt-2">
                    HERE’S another important thing to Remember– up to{" "}
                    <b className="text-dark ">
                      <b className="text-danger">88%</b> of the money{" "}
                      <b className="text-dark">F</b>
                      <b className="text-primary">H</b>
                      <b className="text-danger">P</b> spend at FHP goes{" "}
                      <b className="text-danger">
                        <u> directly to Student Athletes.</u>
                      </b>
                    </b>
                  </p>
                  <p className="font-weight-normal mt-2">
                    <b className="text-dark">THANK YOU!</b>{" "}
                    <u className="text-dark">Enjoy</u> and{" "}
                    <b className="text-dark">
                      <u>TELL YOUR FRIENDS.</u>
                    </b>
                  </p>
                </Col>
                <Col className="col-5">
                  <div className="w-full mt-5 mb-3 d-flex justify-content-center">
                    <img src={previewTalkingBadge} height={200} />
                  </div>

                  <div className="d-flex justify-content-center align-items-center mt-5">
                    <Button color="primary">
                      <a
                        href="https://www.youtube.com/watch?v=UjNrz3IO-Do​​"
                        target="_blank"
                        className="text-white"
                      >
                        Play Video
                      </a>
                    </Button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      href={getContinueLink()}
                      className="btn btn-primary"
                      target="_blank"
                    >
                      Continue
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default Badges;
